import ActorDescription from './ActorDescription';

export default ActorDescription;
